var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPunishDissenters5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 3C46.3594 3 58 14.6407 58 29C58 43.3594 46.3594 55 32 55C17.6406 55 6 43.3594 6 29C6 14.6407 17.6406 3 32 3Z",
    stroke: "#E3000F",
    strokeWidth: 2.6664,
    strokeMiterlimit: 22.9256,
    strokeDasharray: "13.33 13.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74162 48.3338C3.80322 48.39 4.05911 48.5126 4.50964 48.6966C4.96324 48.878 5.38429 49.0859 5.77389 49.3154C6.16322 49.5474 6.5071 49.8645 6.8031 50.2701C7.09897 50.6753 7.24829 51.1658 7.24829 51.7445C7.20562 52.6648 6.95244 53.4434 6.48564 54.0779C6.01657 54.7125 5.43229 55.1873 4.72856 55.4994C4.02442 55.8086 3.3123 55.9711 2.59497 55.9847L2.70455 55.4246C3.22428 55.4246 3.75231 55.3101 4.28857 55.0781C4.82457 54.8486 5.26978 54.5258 5.61898 54.1101C5.96858 53.6939 6.14429 53.2271 6.14429 52.7045C6.14429 52.0514 5.99245 51.5286 5.68591 51.1368C5.37898 50.7448 4.9099 50.3925 4.2723 50.0808C3.58976 49.7285 3.16042 49.4858 2.98722 49.3501C2.81376 49.2141 2.72042 49.0301 2.70455 48.798C2.74722 48.5285 2.77112 48.3312 2.77112 48.2088C2.97098 46.0994 3.08859 45.0275 3.12032 44.9927H6.89644V46.2086H3.58179C3.46432 46.9554 3.40044 47.3927 3.38977 47.5205C3.4299 47.9234 3.54695 48.1924 3.74162 48.3338Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0221 46.5317C13.1404 46.5317 14.0472 47.5432 14.0472 48.7904C14.0472 50.0381 13.1404 51.0491 12.0221 51.0491C10.9037 51.0491 9.99707 50.0381 9.99707 48.7904C9.99707 47.5432 10.9037 46.5317 12.0221 46.5317Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0221 46.5317C13.1404 46.5317 14.0472 47.5432 14.0472 48.7904C14.0472 50.0381 13.1404 51.0491 12.0221 51.0491C10.9037 51.0491 9.99707 50.0381 9.99707 48.7904C9.99707 47.5432 10.9037 46.5317 12.0221 46.5317Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0618 54.4861H7.93384C7.93384 52.3356 9.78207 50.5917 12.0618 50.5917C14.3417 50.5917 16.1898 52.3356 16.1898 54.4861H12.0618Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0618 54.4861H7.93384C7.93384 52.3356 9.78207 50.5917 12.0618 50.5917C14.3417 50.5917 16.1898 52.3356 16.1898 54.4861H12.0618Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1211 16L37.6815 19.5786L44.2424 23.1569L37.6814 27.2358L31.1814 30.7358L24.5605 26.7358L18 23L24.5605 19.5786L31.1211 16Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5404 37.6996L18.3606 30.468L18.1814 23.2358L24.6814 26.7358L31.1812 30.7358V37.7358V45.2358L24.8609 41.4677L18.5404 37.6996Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1814 30.7358L37.8609 27.0039L44.1814 23.2358L44.0018 30.4681L43.8224 37.7001L37.5019 41.4677L31.1814 45.2358V38.2358V30.7358Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1122.52,
    height: 1587.4,
    fill: "white",
    transform: "translate(-593 -830)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPunishDissenters5);
export default __webpack_public_path__ + "static/media/punish_dissenters5.2a5b6bc91e720d0ad72897c2fa34753c.svg";
export { ForwardRef as ReactComponent };